

export default {
    fullSet: 'FULL_SET',
    top: 'TOP',
    bottom: 'BOTTOM',
    mixed: 'MIXED'
}